// Page transition plugin for enhanced user experience
// Handles smooth transitions between pages when navigation occurs

export default defineNuxtPlugin(() => {
  // This plugin is intentionally minimal to avoid SSR/hydration issues
  // Page transitions are handled via CSS classes defined in nuxt.config.ts
  
  if (process.client) {
    console.debug('[Page Transitions] Client-side transitions initialized')
  }
})
